module.exports = __webpack_public_path__ + "static/media/bgSeaFreight.43c0aa2f.jpg";